import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { AuthService } from '@main-client/src/app/auth/auth.service';

import get from 'lodash-es/get';

@Injectable()
export class InvitationLegacyGuardService {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const inviteCode = get(route, 'params.inviteCode');
    const routePath = this.authService.$isLoggedIn() ? ['/hubs'] : ['/signup'];
    return this.router.createUrlTree(routePath, {
      queryParams: { inviteCode },
    });
  }
}
